import axios from 'axios';
import axiosInstance from '../helpers/axios';
import {
	handleError,
	handleInfo,
	handleSuccess,
	round2,
} from '../helpers/utils';
import { getSortedBiases, getSubBiases } from './biases';

// Pilu URL base
const URLBase = 'https://30c3dfd.online-server.cloud/api/pilu/';

const printFile = (blobURL) => {
	handleInfo('Generando PDF');
	// Load content in an iframe to print later
	const iframe = document.createElement('iframe');
	// Generate and configure 'iframe' element in document
	document.body.appendChild(iframe);
	iframe.style.display = 'none';
	iframe.src = blobURL;

	// Print ir when it's loaded
	iframe.onload = function () {
		setTimeout(function () {
			iframe.focus();
			iframe.contentWindow.print();
		}, 1);
	};
};

export const openFileInPreviewer = (response) => {
	// Create file
	const file = new Blob([response.data], {
		type: 'application/pdf',
	});
	// Create blob url
	const blobURL = window.URL.createObjectURL(file);
	// Print file
	printFile(blobURL);
};

export const openFileInAnotherTab = (
	response,
	filename = 'Reporte',
	download = false
) => {
	try {
		// URL
		const url = window.URL.createObjectURL(new Blob([response.data]));

		// Create link
		const link = document.createElement('a');

		link.href = url;

		if (download) {
			link.setAttribute('download', filename); //`${payload.quotationKey}.pdf`);
		} else {
			// Set link
			document.body.appendChild(link);
		}
		link.click();

		handleSuccess('Reporte generado');
	} catch (error) {
		handleError(
			error,
			'Hubo un error al crear el reporte de la orden de pedido [1]'
		);
	}
};

export const generateReport = async (order = null, withAmount = false) => {
	handleInfo('Generando PDF...');
	const sortCriteria = localStorage.getItem(
		'sortCriteriaBiases',
		sortCriteria
	);
	const { results: biases = [] } = (
		await getSortedBiases(order.id, sortCriteria)
	).data;

	const biasesWithSubbiases = biases.map(async (bias) => {
		const { results: subbiases } = (await getSubBiases(bias.id)).data;

		const sizes = subbiases.map((subbias) => ({
			name: subbias.size.name,
			units: subbias.units,
		}));

		const variablesNames = bias.variable.map((item) => item.name);

		delete bias.created_by.token;
		delete bias.created_by.password;
		delete bias.created_by.img_profile;

		delete bias.order.created_by.token;
		delete bias.order.created_by.password;
		delete bias.order.created_by.img_profile;

		return {
			...bias,
			sizes,
			variables: variablesNames,
		};
	});

	// Get all biases
	const pedidos = await Promise.all(biasesWithSubbiases);

	// Calculate subtotal, iva and total
	const subtotal_global = pedidos.reduce(
		(sum, { subtotal }) => sum + subtotal,
		0
	);

	const iva_global = subtotal_global * 0.16;
	const total_price_global = subtotal_global * 1.16;

	return (
		await axios({
			url: URLBase + (withAmount ? 'import_and_price' : 'pdf'),
			method: 'POST',
			responseType: 'blob',
			data: {
				division: order.division,
				number_order: order.number_order,
				pedidos,
				subtotal: round2(subtotal_global),
				iva: round2(iva_global),
				total: round2(total_price_global),
				transport: order?.transport,
				consigned_to: order?.consigned_to,
			},
		})
	).data;
};

export const generateQuotationReport = async (payload) => {
	handleInfo('Generando PDF...', 6);

	return await axiosInstance({
		url: URLBase + 'price',
		method: 'POST',
		responseType: 'blob',
		data: payload,
	})
		.then((response) => {
			openFileInAnotherTab(
				response,
				`${payload.quotationKey}_COT.pdf`,
				true
			);
		})
		.catch((error) => {
			handleError(
				error,
				'Hubo un error al crear el reporte de la orden de pedido [2]'
			);
		});
};

// INCIDENT REPORT
export const generateIncidentReport = async (payload) => {
	handleInfo('Generando reporte de incidencia...', 6);

	return await axiosInstance({
		url: URLBase + 'incident',
		method: 'POST',
		responseType: 'blob',
		data: payload,
	})
		.then((response) => {
			openFileInAnotherTab(
				response,
				`${payload.incident_number}.pdf`,
				true
			);
		})
		.catch((error) => {
			handleError(
				error,
				'Hubo un error al crear el reporte de la orden de pedido [2]'
			);
		});
};

// EXTERNAL TOLLING
export const generateExternalTollingExportReport = async (payload) => {
	handleInfo('Generando reporte de incidencia...', 6);

	return await axiosInstance({
		url: URLBase + 'pdf_out',
		method: 'POST',
		responseType: 'blob',
		data: payload,
	})
		.then((response) => {
			openFileInAnotherTab(
				response,
				`petición_maquila_externa_${payload.id}.pdf`,
				true
			);
		})
		.catch((error) => {
			handleError(
				error,
				'Hubo un error al crear el reporte de la orden de pedido [2]'
			);
		});
};


// INCIDENT REPORT
export const generateMonthProductionPlan = async (payload) => {
	handleInfo('Generando plan de producción...', 6);

	return await axiosInstance({
		url: URLBase + 'pdf_month_plan',
		method: 'POST',
		responseType: 'blob',
		data: payload,
	})
		.then((response) => {
			openFileInAnotherTab(
				response,
				`${payload.file_name}.pdf`,
				true
			);
		})
		.catch((error) => {
			handleError(
				error,
				'Hubo un error al crear el plan mensual'
			);
		});
};